import request from '../../api/request';
import {
  PaginationQuery,
  PaginationRequestType,
} from '../../types/paginationRequestType';
import {
  Announcement,
  AnnouncementFormData,
  AnnouncementFormRequest,
} from './types';

const ADMIN_ENDPOINTS = {
  PAGINATED: `maintainers-portal/management-tools/announcements`,
  FORM: `maintainers-portal/management-tools/announcements/form`,
  CREATE: `maintainers-portal/management-tools/announcements/create`,
  UPDATE: (announcementId: number | string) =>
    `maintainers-portal/management-tools/announcements/update/${announcementId}`,
  REMOVE: (announcementId: number | string) =>
    `maintainers-portal/management-tools/announcements/delete/${announcementId}`,
};

const ENDPOINTS = {
  LIST: `maintainers-portal/announcements`,
};

export const list = () => {
  return request<Announcement[]>(ENDPOINTS.LIST);
};

export const adminPaginated = (params: PaginationQuery) => {
  return request<PaginationRequestType<Announcement>>(
    ADMIN_ENDPOINTS.PAGINATED,
    {
      params: {
        ...params,
        page: params.page - 1,
      },
    },
  );
};

export const formData = () => {
  return request<AnnouncementFormData>(ADMIN_ENDPOINTS.FORM);
};

export const create = (data: AnnouncementFormRequest) => {
  return request<AnnouncementFormData>(ADMIN_ENDPOINTS.CREATE, {
    method: 'POST',
    data,
  });
};

export const update = (
  announcementId: number | string,
  data: AnnouncementFormRequest,
) => {
  return request<AnnouncementFormData>(ADMIN_ENDPOINTS.UPDATE(announcementId), {
    method: 'PUT',
    data,
  });
};

export const remove = (announcementId: number | string) => {
  return request<AnnouncementFormData>(ADMIN_ENDPOINTS.REMOVE(announcementId), {
    method: 'DELETE',
  });
};
